import {StockStatus} from '@/constants/stock-status';
import {stockDispatchActions} from '@/store/modules/product-stock-data';
import {retailerActions} from '@/store/modules/retailer-search';
import Variant from '@/utils/variant-helpers';
import {mapActions, mapMutations, mapState} from 'vuex';

const ProductDetails = {
  props: {
    product: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    copyPositioningStatement: {
      type: String,
      default: '',
      required: false,
    },
    isLocationPostalCodeCorrect: {
      type: Boolean,
      default: false,
      required: false,
    },
    isPdp: {
      type: Boolean,
      default: false,
    },
    retailerData: Object,
    stockMessage: Object,
  },

  watch: {
    variantCode(value) {
      const variant = Variant(value, this.product, this.b2b).get();
      //if locally disabled, load nearby retailer information
      if (
        (!this.showLocallyWidget && !this.options?.isLocallyActive) ||
        (this.b2b && this.options.rpaFunctionalityActive)
      ) {
        if (!variant) return;
        const loadRetailerPayload = {
          variant: variant,
          inStockOnly: this.rpaViewInStock ?? false,
        };
        this.$store.dispatch(retailerActions.LOAD_RETAILER_DATA, loadRetailerPayload);
      }
      const stockStatus = !value ? StockStatus.NOT_AVAILABLE : variant?.globalStockStatus;
      this.$store.dispatch(stockDispatchActions.RETRIEVE_STOCK_MESSAGE, {stockStatus});
    },
  },

  computed: {
    ...mapState('backend', ['b2b', 'isConsumerFriendlyMode']),
    ...mapState('productBundle', ['buyingZoneQuantity']),
    ...mapState('productDetails', ['rpaViewInStock', 'isCustomizationMode']),

    variant() {
      return Variant(this.variantCode, this.product, this.b2b).get() ?? {};
    },

    isPurchasable() {
      return this.variant?.isPurchasable;
    },

    isLocallyStockVariantAvailable() {
      return this.variant?.isLocallyStockAvailable;
    },

    isBike() {
      return this.product?.productType === 'bike';
    },

    projectOneUrl() {
      return this.product.projectOneUrl ?? '';
    },

    hasImages() {
      return this.product.assetImageList && Object.keys(this.product.assetImageList).length > 0;
    },
  },

  methods: {
    ...mapMutations('productBundle', [
      'setIsVariantCode',
      'setBundleMainProductMetaData',
      'setBundleMainProductName',
      'setBundleMainProductUrl',
      'setBundleMainProductQuantity',
    ]),
    ...mapActions('productBundle', ['clearMainBundleProducts']),

    updateShowLocallyWidget(state) {
      this.showLocallyWidget = state;
      if (state) {
        this.$emit('loadRpaResults', this.variantCode);
      }
    },

    getBuyingZoneBundleProductData(variantCode) {
      this.clearMainBundleProducts();
      this.setIsVariantCode(variantCode);
      this.setBundleMainProductName(this.product.name);
      this.setBundleMainProductQuantity(this.buyingZoneQuantity);

      const variantImage = document.querySelector('#heroCarousel .swiper-slide-active img');
      if (variantImage) {
        this.setBundleMainProductUrl(variantImage.src);
      }
    },
  },

  data() {
    return {
      variantCode: '',
      showLocallyWidget: this.options?.isLocallyActive && !this.isCustomizationMode,
      selectedOption: null,
    };
  },
};

export {ProductDetails};
